import { TextField } from "../../../atoms/Form";
import { type ConstructedTextField } from "../types";

export const FIELD_NAME_LAST_NAME = "lastName";

const tLabel = "Last Name";
const tRequired = "Last name is required";
const tLengthMax = "Last name cannot exceed 200 characters";
const tLengthMin = "Last name must be at least 2 characters";

export type LastNameProps = ConstructedTextField & { required?: boolean };

export const LastName = ({ textFieldProps, ...props }: LastNameProps) => {
  return (
    <TextField
      name={FIELD_NAME_LAST_NAME}
      textFieldProps={{
        inputProps: { maxLength: 200, minLength: 2 },
        label: tLabel,
        ...props,
        ...textFieldProps,
      }}
      validate={(value, _, meta) => {
        if (props.required && meta?.modified && !value) {
          return tRequired;
        }

        if (meta?.dirty && value) {
          if (value.length < 2) {
            return tLengthMin;
          }

          if (value.length > 200) {
            return tLengthMax;
          }
        }

        return "";
      }}
      {...props}
    />
  );
};
